
<template>
  <div>
    <!-- b-table -->
    <b-skeleton-table
      v-if="is_loading"
      :rows="9"
      :columns="10"
      :table-props="{ bordered: true, striped: true }"
    ></b-skeleton-table>
    <div>
      <div class="d-flex">
        <GenericButtonDownload
          v-if="!is_loading && professor_progression"
          :tooltip_text="$t('toolbar.reports.reportXlsx')"
          :click_button="DownloadExcel"
          :class="`ml-auto mr-0`"
          :disabled_button="disabled_button_excel"
          :icon_excel="true"
        ></GenericButtonDownload>
      </div>
    </div>
    <b-table-simple
      bordered
      no-border-collapse
      small
      responsive
      sticky-header="80vh"
      v-if="!is_loading && professor_progression"
    >
      <b-thead>
        <b-tr>
          <b-th class="text-center align-middle primary-header" colspan="17">
            <div class="d-flex align-items-center justify-content-between">
              <span class="text-center mx-auto">
                {{
                  $getVisibleNames(
                    "manual.reporte.progression",
                    false,
                    $t("toolbar.reports.progressionReportTitle", {
                      evaluations: $getVisibleNames(
                        "evaluations2.evaluation",
                        true,
                        "evaluaciones"
                      ),
                    })
                  ).toUpperCase()
                }}
              </span>
            </div>
          </b-th>
        </b-tr>
        <b-tr>
          <b-th class="text-center align-middle secondary-header">
            {{ $getVisibleNames("evaluations2.test", false, "Instrumento") }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{
              $getVisibleNames("evaluations2.evaluation", false, "Evaluación")
            }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{
              $t("toolbar.reports.evaluationType", {
                evaluation: $getVisibleNames(
                  "evaluations2.evaluation",
                  false,
                  "Evaluación"
                ),
              })
            }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{ $t("reusable.common.startDate") }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{ $t("reusable.common.endDate") }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{ $t("evaluations.newEvaluations.visibleByEvaluatees") }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{ $getVisibleNames("teaching.section", false, "Sección") }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{ $getVisibleNames("mesh.period", false, "Período") }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{ $t("toolbar.reports.professors") }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{ $getVisibleNames("mesh.campus", false, "Sede") }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{
              $getVisibleNames("mesh.egressprofilematter", false, "Asignatura")
            }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{
              $getVisibleNames("mesh.egressprofile", false, "Perfil de Egreso")
            }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{ $t("toolbar.reports.studentsStarted") }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{ $t("toolbar.reports.studentsStartedNotFinished") }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{ $t("toolbar.reports.studentsFinished") }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{ $t("toolbar.reports.studentsGradePublished") }}
          </b-th>
          <b-th class="text-center align-middle secondary-header">
            {{ $t("toolbar.reports.totalStudents") }}
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <b-tr
          v-for="professor_report in professor_progression.tests"
          :key="`professor-progression-report-${professor_report.test_id}`"
        >
          <!-- Instrumento -->
          <b-td class="align-content-center">
            {{ professor_report.test_title }}
          </b-td>
          <!-- Evaluacion -->
          <b-td class="align-content-center">
            {{ professor_report.evaluation_title }}
          </b-td>
          <!-- Tipo de Evaluacion -->
          <b-td class="align-content-center">
            {{ professor_report.type }}
          </b-td>
          <!-- Fecha de Inicio -->
          <b-td class="align-content-center">
            {{ professor_report.start_date | FormatToDateTime }}
          </b-td>
          <!-- Fecha de Termino -->
          <b-td class="align-content-center">
            {{ professor_report.end_date | FormatToDateTime }}
          </b-td>
          <!-- Visible para el Estudiante -->
          <b-td class="align-content-center">
            {{
              professor_report.visible_by_evaluatees
                ? $t("reusable.common.yes")
                : $t("reusable.common.no")
            }}
          </b-td>
          <!-- Seccion -->
          <b-td class="align-content-center">
            <span
              :id="`popover-button-variant-${professor_report.evaluation_id}-${professor_report.test_id}`"
              class="div-href"
            >
              {{ professor_report.section.name }}
            </span>
            <b-popover
              :target="`popover-button-variant-${professor_report.evaluation_id}-${professor_report.test_id}`"
              triggers="hover"
            >
              <template #title
                >{{ $t("toolbar.reports.navigation") }}:</template
              >
              <div>
                <template>
                  <div class="profiles-container">
                    <b-button
                      variant="secondary"
                      @click="redirectToSection(professor_report.section.id)"
                      @contextmenu.prevent="
                        handleRightClickSection(professor_report.section.id)
                      "
                      class="btn-popover-my-classes mb-2 w-100"
                    >
                      {{
                        $t("toolbar.reports.sectionGrades", {
                          section: $getVisibleNames(
                            "teaching.section",
                            false,
                            "Sección"
                          ),
                        })
                      }}
                    </b-button>
                    <b-button
                      variant="secondary"
                      @click="
                        redirectToEvaluationTeacher(professor_report.section.id)
                      "
                      @contextmenu.prevent="
                        handleRightClickEvaluationTeacher(
                          professor_report.section.id
                        )
                      "
                      class="btn-popover-my-classes mb-2 w-100"
                    >
                      {{
                        $t("toolbar.reports.sectionEvaluations", {
                          evaluations: $getVisibleNames(
                            "evaluations2.evaluation",
                            true,
                            "Evaluaciones"
                          ),
                          section: $getVisibleNames(
                            "teaching.section",
                            false,
                            "Sección"
                          ),
                        })
                      }}
                    </b-button>
                  </div>
                </template>
              </div>
            </b-popover>
          </b-td>
          <!-- Periodo -->
          <b-td class="align-content-center">
            {{ professor_report.period.name }}
          </b-td>
          <!-- Profesores -->
          <b-td class="align-content-center">
            {{ professor_report.professors.map((x) => x.name).join(", ") }}
          </b-td>
          <!-- Sede -->
          <b-td class="align-content-center">
            {{ professor_report.campus.name }}
          </b-td>
          <!-- Asignatura -->
          <b-td class="align-content-center">
            {{ professor_report.matter.code
            }}<template
              v-if="
                institution &&
                institution.use_epm_code &&
                professor_report.matter.epm_code &&
                professor_report.matter.epm_code !== professor_report.matter.code
              "
            >
              - {{ professor_report.matter.epm_code }}</template
            >
            -
            {{ professor_report.matter.name }}
          </b-td>
          <!-- Perfil de Egreso -->
          <b-td class="align-content-center">
            {{ professor_report.egress_profile.name }}
          </b-td>
          <!-- Estudiantes que iniciaron -->
          <b-td class="align-content-center">
            {{
              professor_report.total_students -
              professor_report.students_not_started
            }}
          </b-td>
          <!-- Estudiantes que iniciaron pero no terminaron -->
          <b-td class="align-content-center">
            {{ professor_report.students_started_not_finished }}
          </b-td>
          <!-- Estudiantes que terminaron -->
          <b-td class="align-content-center">
            {{ professor_report.students_finished }}
          </b-td>
          <!-- Estudiantes con Nota publicada -->
          <b-td class="align-content-center">
            {{ professor_report.students_grade_published }}
          </b-td>
          <!-- Total de estudiantes -->
          <b-td class="align-content-center">
            {{ professor_report.total_students }}
          </b-td>
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
// import * as names from "@/store/names";
import { mapGetters } from "vuex";
import {
  showLoadingAlert,
  downloadFileFromResponse,
  EventBus,
} from "@/utils/utils";

export default {
  name: "ProfessorProgressionReportTable",
  components: {
    GenericButtonDownload: () =>
      import("@/components/reusable/Buttons/GenericButtonDownload"),
  },
  props: {
    campuses_: {
      type: Array,
    },
    egress_profiles_: {
      type: Array,
    },
    levels_: {
      type: Array,
    },
    matters_: {
      type: Array,
    },
    periods_: {
      type: Array,
    },
    sections_: {
      type: Array,
    },
    professors_: {
      type: Array,
    },
    is_active_section_: {
      type: Array,
    },
    selected_is_active_section: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      is_loading: false,
      disabled_button_excel: false,
      professor_progression: null,
    };
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
    }),
    isOnTrack() {
      if (this.selected_is_active_section == 1) return true;
      else if (this.selected_is_active_section == 2) return false;
      return null;
    },
  },
  methods: {
    redirectToSection(id) {
      this.$router.push({
        name: "NewFullGradingView",
        params: {
          section_id: id,
        },
      });
    },
    handleRightClickSection(id) {
      const url = this.$router.resolve({
        name: "NewFullGradingView",
        params: {
          section_id: id,
        },
      }).href;
      // Abre la URL en una nueva pestaña
      window.open(url, "_blank");
    },
    redirectToEvaluationTeacher(id) {
      this.$router.push({
        name: "EvaluatorEvaluationsListView",
        params: {
          section_id: id,
        },
      });
    },
    handleRightClickEvaluationTeacher(id) {
      const url = this.$router.resolve({
        name: "EvaluatorEvaluationsListView",
        params: {
          section_id: id,
        },
      }).href;
      // Abre la URL en una nueva pestaña
      window.open(url, "_blank");
    },
    DownloadExcel() {
      this.disabled_button_excel = true;
      let payload = {};
      let url = `/evaluations2/professor_progression_report_excel/`;

      if (this.egress_profiles_ && this.egress_profiles_.length > 0) {
        payload["egress_profiles"] = this.egress_profiles_.map((x) => x.id);
        // url += `&egress_profiles=${this.egress_profiles_[0].id}`;
      }
      if (this.matters_ && this.matters_.length > 0) {
        payload["matters"] = this.matters_.map((x) => x.matter);
        // url += `&matters=${this.matters_[0].matter}`;
      }
      if (this.sections_ && this.sections_.length > 0) {
        payload["sections"] = this.sections_.map((x) => x.id);

        // url += `&sections=${this.sections_[0].id}`;
      }
      if (this.campuses_ && this.campuses_.length > 0) {
        payload["campuses"] = this.campuses_.map((x) => x.id);
        // url += `&campuses=${this.campuses_[0].id}`;
      }
      if (this.periods_ && this.periods_.length > 0) {
        payload["periods"] = this.periods_.map((x) => x.id);
        // url += `&periods=${this.periods_[0].id}`;
      }
      if (this.professors_ && this.professors_.length > 0) {
        payload["professors"] = this.professors_.map((x) => x.id);
        // url += `&professors=${this.professors_[0].id}`;
      }
      payload["is_active"] = this.isOnTrack;

      showLoadingAlert(
        this.$t("reusable.common.generatingExcel"),
        this.$t("reusable.common.pleaseWaitFile")
      );
      this.$restful
        .Post(url, payload, {
          responseType: "blob",
        })
        .then((response) => {
          this.$swal.close();
          if (response) {
            downloadFileFromResponse(
              response,
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              () => {
                this.disabled_button_excel = false;
              },
              () => {
                this.disabled_button_excel = false;
                this.$swal.fire(
                  this.$t("reusable.common.error"),
                  this.$t("reusable.common.downloadError"),
                  "error"
                );
              }
            );
          } else {
            this.disabled_button_excel = false;
            this.$swal.fire(
              this.$t("reusable.common.error"),
              this.$t("reusable.common.generateError"),
              "error"
            );
          }
        })
        .catch(() => {
          this.disabled_button_excel = false;
          this.$swal.close();
          this.$swal.fire(
            this.$t("reusable.common.error"),
            this.$t("reusable.common.problemGenerating"),
            "error"
          );
        });
    },
    getProfessorProgression() {
      this.is_loading = true;
      let payload = {};
      let url = `/evaluations2/professor_progression_report/`;

      if (this.egress_profiles_ && this.egress_profiles_.length > 0) {
        payload["egress_profiles"] = this.egress_profiles_.map((x) => x.id);
        // url += `&egress_profiles=${this.egress_profiles_[0].id}`;
      }
      if (this.matters_ && this.matters_.length > 0) {
        payload["matters"] = this.matters_.map((x) => x.matter);
        // url += `&matters=${this.matters_[0].matter}`;
      }
      if (this.sections_ && this.sections_.length > 0) {
        payload["sections"] = this.sections_.map((x) => x.id);

        // url += `&sections=${this.sections_[0].id}`;
      }
      if (this.campuses_ && this.campuses_.length > 0) {
        payload["campuses"] = this.campuses_.map((x) => x.id);
        // url += `&campuses=${this.campuses_[0].id}`;
      }
      if (this.periods_ && this.periods_.length > 0) {
        payload["periods"] = this.periods_.map((x) => x.id);
        // url += `&periods=${this.periods_[0].id}`;
      }
      if (this.professors_ && this.professors_.length > 0) {
        payload["professors"] = this.professors_.map((x) => x.id);
        // url += `&professors=${this.professors_[0].id}`;
      }
      payload["is_active"] = this.isOnTrack;

      this.$restful
        .Post(url, payload)
        .then((response) => {
          this.professor_progression = response;
          this.$swal.close();
          EventBus.$emit("report_request_finished");
          this.is_loading = false;
        })
        .catch(() => {
          this.is_loading = false;
          this.$swal.close();
          EventBus.$emit("report_request_finished");
          this.$swal.fire(
            "",
            this.$t("toolbar.reports.noSectionsFoundWithFilters"),
            "info"
          );
        });
    },
  },
  created() {
    this.getProfessorProgression();
  },
};
</script>

<style scoped>
.primary-header {
  background-color: var(--kl-color-accent-medium) !important;
  color: white !important;
}
.secondary-header {
  background: var(--kl-table-header-bg) !important;
  color: var(--kl-table-header-text);
  min-width: 100px !important;
}
.div-href {
  color: #007bff;
}
.div-href:hover {
  color: #0057b1 !important;
  text-decoration: underline;
  cursor: pointer;
}

@media print {
  .table-b-table-default {
    max-height: none !important;
    overflow: visible !important;
  }
}
</style>

